
export default {
  root: {
    borderRadius: '1.6rem'
  }
};
